import React, { CSSProperties } from 'react'

import { TravelTypeEnum } from '../../../../lib/graphql'
import { Icon } from '../../../atoms'

interface TravelTypeIconProps {
  travelType: TravelTypeEnum
  style?: Pick<CSSProperties, 'height' | 'width' | 'color'>
}
export const TravelTypeIcon = ({ style, travelType }: TravelTypeIconProps) => {
  const iconStyle = { size: 14, ...style }

  switch (travelType) {
    case TravelTypeEnum.CORPORATE_EVENING_EVENT:
      return <Icon name='celebration' {...iconStyle} />
    case TravelTypeEnum.DAILY_TRIP:
      return <Icon name='sun' {...iconStyle} />
    case TravelTypeEnum.NIGHTLY_TRIP:
      return <Icon name='moon' {...iconStyle} />
    case TravelTypeEnum.TEAM_BUILDING:
      return <Icon name='happy-team' {...iconStyle} />
    case TravelTypeEnum.BUSINESS_MEAL:
      return <Icon name='dinner' {...iconStyle} />
    case TravelTypeEnum.TRANSPORT:
      return <Icon name='mini-bus' {...iconStyle} />
    default:
      return <Icon name='question-mark' {...iconStyle} />
  }
}
